<template>
    <MainContent title="Detalle del pack:">
        <template v-slot:header v-if="pack">
            <b-col cols="12">
                <span class="h3">{{ pack.name }}</span>
                <b-button 
                    class="float-right"
                    :to="{ name: 'back.packs-events.show.precios' }"
                >
                    Configurar precios
                </b-button>
            </b-col>
        </template>    
        <template v-slot:content v-if="pack">
            <b-row>
                <b-col cols="12 text-center" v-if="pack.image" class="mb-4">
                    <b-img
                        :src="pack.image"
                        fluid
                        style="max-height: 200px;"
                    />
                </b-col>
                <b-col cols="12">
                    <p v-html="pack.description"></p>
                </b-col>
                <b-col cols="12">
                    <hr/>
                </b-col>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="6">
                            <h4>Eventos y sesiones:</h4>
                        </b-col>
                        <b-col cols="6" class="text-right">
                            <AddEventModal
                                :pack_id="pack.id"
                                @actualizar="getPack()"
                            />
                        </b-col>
                        <b-col 
                            cols="12" 
                            v-if="pack.sesiones.length > 0"
                        >
                            <b-table
                                :items="pack.sesiones"
                                :fields="fields"
                            >
                                <template #cell(opciones)="{ item }">
                                    <b-button @click="showModal('quitar-evento-' + item.evento_id)">
                                        Quitar
                                    </b-button>
                                    <BorrarModalComponent
                                        :name="'quitar-evento-' + item.evento_id"
                                        :title="'¿Desea borrar el evento ' + item.evento + ' del pack partidos?'"
                                        confirmButton="¿Está segur@ de borrar el evento del pack?"
                                        v-on:close="() => closeModal('quitar-evento-' + item.evento_id)"
                                        v-on:confirm="() => quitarEvento(item.evento_id, item.id)"
                                    />
                                </template>
                            </b-table>
                        </b-col>
                        <b-col cols="12" v-else class="p-4">
                            <b-alert show variant="warning">No hay ningún evento ni sesión en este pack</b-alert>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue'
    import AddEventModal from '@/components/backend/pack-eventos/modals/AddEventModal.vue'
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        props: ['pack_id'],
        data() {
            return {
                pack: null,
                fields: [
                    'evento', 
                    {
                        key: 'date',
                        label: 'Sesión'
                    },
                    'opciones'
                ]
            }
        },
        created() {
            this.getPack()
        },
        methods: {
            getPack() {
                const params = {
                    filters : {},
                    pack_id: this.pack_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show'), params).then(res => {
                    this.pack = res.data.data;
                });
            },
            quitarEvento(evento_id, sesion_id) {
                const params = {
                    filters : {},
                    pack_id: this.pack_id,
                    evento_id: evento_id,
                    sesion_id: sesion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.quitar-evento'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getPack();
                }).catch(error => {
                    this.$toast.success(error.response.data.message);
                });
            },
            showModal(modal) {
                this.$modal.show(modal)
            },
            closeModal(modal) {
                this.$modal.hide(modal)
            }
        },
        components: {
            MainContent, AddEventModal, BorrarModalComponent
        }
    }
</script>
